import { Button, Flex, Table } from "antd";
import { SearchOutlined, CloseCircleOutlined } from "@ant-design/icons";
import styles from "../Assets/taskCoworkerFilter.module.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchActiveUsersList } from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

function AssigneeModal({
  modalOpen,
  modalHideEv,
  selectedUsers,
  setSelectedUsers,
  isBuildingBlock,
}) {
  const dispatch = useDispatch();
  const [activeView, setActiveView] = useState(1);
  const [searchItems, setSearchItems] = useState("");
  const [usersData, setUsersData] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [selected, setSelected] = useState([]);
  const companyId = window.localStorage.getItem("companyid");
  const fetchAssigneeResponse = useSelector(
    (state) => state.user.fetchAssigneeResponse
  );

  useEffect(() => {
    if (companyId) {
      dispatch(FetchActiveUsersList(companyId));
    }
  }, [dispatch, companyId]);

  useEffect(() => {
    setSelected(selectedUsers);
  }, [selectedUsers]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  useEffect(() => {
    if (fetchAssigneeResponse?.status === true && fetchAssigneeResponse?.data) {
      setTeamData(
        fetchAssigneeResponse?.data.filter((item) => item.type === "team")
      );
      setUsersData(
        fetchAssigneeResponse?.data.filter((item) => item.type === "user")
      );
    }
  }, [fetchAssigneeResponse]);

  const handleCheckboxChange = (userData) => {
    const oldSelected = [...selected];
    const oldIndex = oldSelected.findIndex((x) => x.userid === userData.userid);
    if (oldIndex === -1) {
      oldSelected.push(userData);
      if (userData.type === "team") {
        userData.teammember.forEach((element) => {
          // remove if same assignee as user
          const individualUserIndex = oldSelected.findIndex(
            (x) => x.userid == element.userid && x.type === "user"
          );
          if (individualUserIndex > -1) {
            oldSelected.splice(individualUserIndex, 1);
          }

          element.type = "team-user";
          element.teamid = userData.userid;
          oldSelected.push(element);
        });
      }
    } else {
      const existingItem = oldSelected[oldIndex];
      oldSelected.splice(oldIndex, 1);
      if (existingItem.type === "team") {
        // removeing same team id members
        existingItem.teammember.forEach((item) => {
          const selectedIndex = oldSelected.findIndex(
            (x) =>
              x.userid === item.userid &&
              x.type === "team-user" &&
              x.teamid === existingItem.userid
          );
          oldSelected.splice(selectedIndex, 1);
        });
      } else if (existingItem.type === "team-user") {
        // existing team
        const sameTeamIndex = oldSelected.findIndex(
          (x) => x.type === "team" && x.userid === existingItem.teamid
        );
        if (sameTeamIndex > -1) {
          const team = oldSelected[sameTeamIndex];
          team.teammember.forEach((i) => {
            if (i.userid != existingItem.userid) {
              const existingOtherTeamMemberIndex = oldSelected.findIndex(
                (x) => x.userid === i.userid && x.teamid === existingItem.teamid
              );
              const existInOtherTeam = oldSelected.some(
                (x) =>
                  x.type === "team-user" &&
                  x.userid === i.userid &&
                  x.teamid !== existingItem.teamid
              );
              if (existInOtherTeam) {
                oldSelected.splice(existingOtherTeamMemberIndex, 1);
              } else {
                oldSelected[existingOtherTeamMemberIndex].type = "user";
                oldSelected[existingOtherTeamMemberIndex].teamid = null;
              }
            }
          });
          oldSelected.splice(sameTeamIndex, 1);
        }

        const selectedUsers = oldSelected.filter(
          (x) => x.type === "team-user" && x.userid === existingItem.userid
        );
        selectedUsers.forEach((item) => {
          const teamUserIndex = oldSelected.findIndex(
            (x) => x.userid === item.userid && x.teamid == item.teamid
          );
          oldSelected.splice(teamUserIndex, 1);

          const teamIndex = oldSelected.findIndex(
            (x) => x.type === "team" && x.userid === item.teamid
          );
          if (teamIndex > -1) {
            const team = oldSelected[teamIndex];
            team.teammember.forEach((i) => {
              if (i.userid != item.userid) {
                const existingOtherTeamMemberIndex = oldSelected.findIndex(
                  (x) => x.userid === i.userid && x.teamid === item.teamid
                );
                const existInOtherTeam = oldSelected.some(
                  (x) =>
                    x.type === "team-user" &&
                    x.userid === i.userid &&
                    x.teamid !== item.teamid
                );
                if (existInOtherTeam) {
                  oldSelected.splice(existingOtherTeamMemberIndex, 1);
                } else {
                  oldSelected[existingOtherTeamMemberIndex].type = "user";
                  oldSelected[existingOtherTeamMemberIndex].teamid = null;
                }
              }
            });
            oldSelected.splice(teamIndex, 1);
          }
        });
      }
    }
    setSelected([...oldSelected]);
    let filtered = oldSelected
      .filter((x) => x.type !== "team-user")
      .map((x) => ({ ...x, assigneeid: x.userid }));
    setSelectedUsers(filtered);
  };

  const generateTableColumns = (isTeamTable) => [
    {
      title: "",
      dataIndex: "userid",
      key: "userid",
      render: (text, record) => (
        <div className="custom-checkbox-wrap">
          <input
            type="checkbox"
            id={`checkbox_${record.userid}`}
            checked={selected.some((x) => x.userid === record.userid)}
            onChange={() => handleCheckboxChange(record)}
          />
          <span className="checkmark"></span>
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "firstname",
      key: "firstname",
      render: (text, record) => (
        <div className={styles.icon_text}>
          <div className={styles.icon_wrap}>
            {record.imageurl ? (
              <img src={record.imageurl} alt="" />
            ) : (
              <div
                style={{
                  backgroundColor: "#95A7C6",
                  color: "#ffffff",
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  border: "2px solid var(--unnamed-color-00246a)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {record?.lastname
                  ? record?.firstname[0]?.toUpperCase() +
                    "" +
                    record?.lastname[0]?.toUpperCase()
                  : record?.firstname?.slice(0, 2).toUpperCase()}
              </div>
            )}
          </div>
          {text}
        </div>
      ),
    },
    {
      title: "",
      dataIndex: isTeamTable ? "teammembercount" : "jobtypename",
      key: isTeamTable ? "teammembercount" : "jobtypename",
      render: (text, record) => (
        <div className={styles.icon_text}>{text ? text + " Member" : "-"}</div>
      ),
    },
  ];

  const partTableColumn = generateTableColumns(false);
  const partTableTeamsColumn = generateTableColumns(true);

  const getFilteredData = () => {
    return activeView === 1
      ? usersData?.filter((item) =>
          item.firstname.toLowerCase().includes(searchItems.toLowerCase())
        )
      : activeView === 2
      ? teamData?.filter((item) =>
          item.firstname.toLowerCase().includes(searchItems.toLowerCase())
        )
      : [];
  };

  return (
    <>
      <div
        className={`${styles.addPartPopupAsset} ${styles.assigneeModal} ${
          modalOpen ? styles.show : ""
        }`}
      >
        <div className={styles.part_popup_inner}>
          <div className={styles.part_popup_header}>
            <div className={styles.title_wrap}>
              <Flex gap="small" className={styles.flex}>
                <div className="kanban-calendar-joint list_toggle_btn">
                  <p
                    className="mb-0 view-k-c"
                    onClick={() => setActiveView(1)}
                    style={{
                      fontSize: "clamp(14px,0.9vw,0.9vw)",
                      backgroundColor:
                        activeView === 1 ? "#00246A" : "transparent",
                      color: activeView === 1 ? "#FFF" : "#A5A5A5",
                    }}
                  >
                    {/* Co-Workers */}
                    {t("Co-Workers")}
                  </p>
                  {isBuildingBlock && (
                    <p
                      className="mb-0 view-k-c"
                      onClick={() => setActiveView(2)}
                      style={{
                        fontSize: "clamp(14px,0.833vw,0.833vw)",
                        backgroundColor:
                          activeView === 2 ? "#00246A" : "transparent",
                        color: activeView === 2 ? "#FFF" : "#A5A5A5",
                      }}
                    >
                      {/* Teams */}
                      {t("Teams")}
                    </p>
                  )}
                </div>
                <div className={styles.search_input}>
                  <input
                    autoFocus={true}
                    type="search"
                    // placeholder="Search"
                    placeholder={t("search ")}
                    onChange={(e) => setSearchItems(e.target.value)}
                  />
                  {!searchItems.length > 0 && (
                    <Button
                      type="text"
                      shape="circle"
                      icon={<SearchOutlined />}
                    />
                  )}
                </div>
              </Flex>
            </div>
            <div className={styles.close_btn_wrap}>
              <Button
                type="text"
                shape="circle"
                icon={<CloseCircleOutlined />}
                onClick={() => modalHideEv(!modalOpen)}
              />
            </div>
          </div>
          <div className={styles.popup_body}>
            <div className={`${styles.table_wrapper} part-table-wrapper`}>
              <Table
                columns={
                  activeView === 1 ? partTableColumn : partTableTeamsColumn
                }
                dataSource={getFilteredData()}
                // for select by row gaurav start.
                onRow={(record) => ({
                  onClick: () => handleCheckboxChange(record),
                })}
                // for select by row gaurav end.
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssigneeModal;
